var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );




var shim = require("/var/www/django/adg.org/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/components/CommonGallery/CommonGallery.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/front/components/CommonGallery/CommonGallery.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("macros", t_1);
output += "\n\n";
var macro_t_4 = runtime.makeMacro(
[], 
["data"], 
function (kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
frame.set("data", Object.prototype.hasOwnProperty.call(kwargs, "data") ? kwargs["data"] : {});var t_5 = "";t_5 += "\n    <div class=\"CommonGallery\">\n        ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"hasTitle") && runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"title")) {
t_5 += "\n            <h2>";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"title"), env.opts.autoescape);
t_5 += "</h2>\n        ";
;
}
t_5 += "\n\n        <figure class=\"CommonGallery-gallery\">\n            <div class=\"CommonGallery-galleryWrapper\">\n                <div class=\"CommonGallery-galleryPlaceholder\" style=\"padding-top: ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"aspect")) {
t_5 += runtime.suppressValue(100 / runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"aspect"), env.opts.autoescape);
;
}
else {
t_5 += "67";
;
}
t_5 += "%\"   data-animation=\"1\" data-animation-type=\"fade\" data-animation-state=\"initial\">\n                    <div class=\"CommonGallery-galleryCarousel owl-carousel owl-theme\">\n                        ";
frame = frame.push();
var t_8 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"images");
if(t_8) {t_8 = runtime.fromIterator(t_8);
var t_7 = t_8.length;
for(var t_6=0; t_6 < t_8.length; t_6++) {
var t_9 = t_8[t_6];
frame.set("item", t_9);
frame.set("loop.index", t_6 + 1);
frame.set("loop.index0", t_6);
frame.set("loop.revindex", t_7 - t_6);
frame.set("loop.revindex0", t_7 - t_6 - 1);
frame.set("loop.first", t_6 === 0);
frame.set("loop.last", t_6 === t_7 - 1);
frame.set("loop.length", t_7);
t_5 += "\n                            <div class=\"CommonGallery-galleryItem\">\n                                ";
if((runtime.memberLookup((t_9),"memberUrl"))) {
t_5 += "<a href=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((t_9),"memberUrl"), env.opts.autoescape);
t_5 += "\">";
;
}
t_5 += "\n                                <img src=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_9),"img")),"w920_url"), env.opts.autoescape);
t_5 += "\"\n                                  srcset=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_9),"img")),"w1680_url"), env.opts.autoescape);
t_5 += " 1680w,\n                                          ";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_9),"img")),"w920_url"), env.opts.autoescape);
t_5 += " 920w,\n                                          ";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_9),"img")),"w680_url"), env.opts.autoescape);
t_5 += " 680w\"\n                                  sizes=\"(max-width: 759px) 1, ";
t_5 += "\n                                         100vw\"\n                                  alt=\"\">\n                                ";
if((runtime.memberLookup((t_9),"memberUrl"))) {
t_5 += "</a>";
;
}
t_5 += "\n\n                                ";
if(runtime.memberLookup((t_9),"caption") || runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"caption")) {
t_5 += "<div class=\"CommonGallery-galleryItemCaption\">";
if(runtime.memberLookup((t_9),"caption")) {
t_5 += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((t_9),"caption")), env.opts.autoescape);
;
}
else {
t_5 += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"caption")), env.opts.autoescape);
;
}
t_5 += "</div>\n                                ";
;
}
t_5 += "</div>\n                        ";
;
}
}
frame = frame.pop();
t_5 += "\n                    </div>\n\n                    <div class=\"CommonGallery-galleryPrev\">\n                        ";
t_5 += runtime.suppressValue((lineno = 32, colno = 46, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "macros")),"svgSprite"), "macros[\"svgSprite\"]", context, ["gallery-arrow-prev","0 0 30 26",runtime.makeKeywordArgs({"caller": (function (){var macro_t_10 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
var callerFrame = frame;
frame = frame.push(true);
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
var t_11 = "";;
frame = frame.pop();
return new runtime.SafeString(t_11);
});
return macro_t_10;})()})])), env.opts.autoescape);
t_5 += "\n                    </div>\n\n                    <div class=\"CommonGallery-galleryNext\">\n                        ";
t_5 += runtime.suppressValue((lineno = 36, colno = 46, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "macros")),"svgSprite"), "macros[\"svgSprite\"]", context, ["gallery-arrow-next","0 0 30 26",runtime.makeKeywordArgs({"caller": (function (){var macro_t_12 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
var callerFrame = frame;
frame = frame.push(true);
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
var t_13 = "";;
frame = frame.pop();
return new runtime.SafeString(t_13);
});
return macro_t_12;})()})])), env.opts.autoescape);
t_5 += "\n                    </div>\n                </div>\n            </div>\n\n\n            ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"button") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"button")),"url")) {
t_5 += "\n                <div class=\"CommonGallery-link  CommonGallery-link--";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"captionStyle"), env.opts.autoescape);
t_5 += "\">\n                    <a href=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"button")),"url"), env.opts.autoescape);
t_5 += "\" ";
if((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"button")),"noReload"))) {
t_5 += "class=\"u-Route\"";
;
}
t_5 += " ";
if((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"button")),"isNewTab"))) {
t_5 += "target=\"_blank\"";
;
}
t_5 += ">";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"button")),"title"), env.opts.autoescape);
t_5 += "</a>\n                </div>\n            ";
;
}
t_5 += "\n\n            <div class=\"CommonGallery-captionWrapper CommonGallery-captionWrapper--";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"captionStyle"), env.opts.autoescape);
t_5 += "\">\n                <figcaption class=\"CommonGallery-caption\"></figcaption>\n            </div>\n\n            ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"button") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"button")),"url")) {
t_5 += "\n                <div class=\"CommonGallery-link  CommonGallery-link--mobile CommonGallery-link--";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"captionStyle"), env.opts.autoescape);
t_5 += "\">\n                    <a href=\"";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"button")),"url"), env.opts.autoescape);
t_5 += "\" ";
if((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"button")),"noReload"))) {
t_5 += "class=\"u-Route\"";
;
}
t_5 += " ";
if((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"button")),"isNewTab"))) {
t_5 += "target=\"_blank\"";
;
}
t_5 += ">";
t_5 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"button")),"title"), env.opts.autoescape);
t_5 += "</a>\n                </div>\n            ";
;
}
t_5 += "\n\n        </figure>\n    </div>\n";
;
frame = callerFrame;
return new runtime.SafeString(t_5);
});
context.addExport("CommonGallery");
context.setVariable("CommonGallery", macro_t_4);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/components/CommonGallery/CommonGallery.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/CommonGallery/CommonGallery.jinja
// module id = 34
// module chunks = 0